//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { CreatorsCampaignsMemberInfo } from '@apis/creators-campaigns/CreatorsCampaignsApiModel';

export enum CreatorPortalLinkType {
  CAMPAIGN_LINK = 'CAMPAIGN_LINK',
  CONTENT_REVIEW_LINK = 'CONTENT_REVIEW_LINK',
  PAYMENT_LINK = 'PAYMENT_LINK',
}

export enum CreatorExportInfoType {
  CREATORS_DETAILS = 'CREATORS_DETAILS',
}

export type CreatorPortalActionType = 'COPY' | 'EXPORT';

interface BaseProps {
  closeModal: (disableWarning?: boolean) => void;
  isModalOpen: boolean;
}

export interface CopyActionProps extends BaseProps {
  actionType: 'COPY';
  creator: CreatorsCampaignsMemberInfo;
  infoType: CreatorPortalLinkType;
  numberOfCreators?: never;
}

export interface ExportActionProps extends BaseProps {
  actionType: 'EXPORT';
  creator?: never;
  infoType: CreatorExportInfoType | CreatorPortalLinkType;
  numberOfCreators?: number;
}

export type CreatorsSensitiveLinkWarningModalProps =
  | CopyActionProps
  | ExportActionProps;
